import { render, staticRenderFns } from "./InventoryRecords.vue?vue&type=template&id=fca36dc8&scoped=true&"
import script from "./InventoryRecords.vue?vue&type=script&lang=ts&"
export * from "./InventoryRecords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca36dc8",
  null
  
)

export default component.exports